/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IChronicCondition } from 'app/shared/model/chronic-condition.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IPastMedicalHistory {
  id?: string;
  illness?: boolean | null;
  illnessDetails?: string | null;
  illnessStartDate?: number | null;
  illnessEndDate?: number | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  condition?: IChronicCondition | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<IPastMedicalHistory> = {
  illness: false,
  active: false,
  draft: false,
};
